import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/page.tsx");
